import axios from "axios";
import config from "./config";

const api = axios.create({
  baseURL: config.portalApiUrl,
  withCredentials: true,
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status;
    const requestUrl = error?.config?.url || "";

    const isAuthCheckRequest =
      requestUrl.includes("/refresh") ||
      requestUrl.includes("/me") ||
      requestUrl.includes("/login");

    if (status === 401 && !isAuthCheckRequest) {
      try {
        sessionStorage.setItem("aei_login_message", "SESSION_EXPIRED");
        sessionStorage.removeItem("aei_portal_access_token");
        localStorage.setItem("aei_portal_logout_at", String(Date.now()));
      } catch (err) {
        console.warn("Could not write session expiry marker:", err);
      }

      window.dispatchEvent(new Event("aei:session-expired"));
    }

    return Promise.reject(error);
  }
);

export default api;